import { GetAllPersonActivitiesUseCaseInterface } from 'domain/usecases';

import {
  formatTimeToCalendar,
  formatTimeToDisplayInEvent,
} from './format-time-to-calendar';

const formatAPIDataToCalendar = (
  events: GetAllPersonActivitiesUseCaseInterface.Result,
) =>
  (events || []).map((event) => {
    const start = formatTimeToCalendar(
      event.actualStart || event.scheduledStart,
    );
    const end = formatTimeToCalendar(event.actualEnd || event.scheduledEnd);

    const formattedStartTime = formatTimeToDisplayInEvent(
      event.actualStart || event.scheduledStart,
    );

    return {
      id: event.id,
      title: `${formattedStartTime} - ${event?.task?.name}`,
      start,
      end,
      classNames: [`bg-${event?.activityStatus?.color}`],
    };
  });

export { formatAPIDataToCalendar };
